import atlas from './Atlas';
import listadoParametros from './ListadoParametros';
import nuevaInstanciaParametro from './NuevaInstanciaParametro';
import vistaInstanciaParametro from './VistaInstanciaParametro';

export default {
    atlas,
    listadoParametros,
    nuevaInstanciaParametro,
    vistaInstanciaParametro
};